/**
 * Cleo ERP SaaS — Layout admin EC Intelligence
 * Sidebar navy + header + contenu.
 */
import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Typography, Dropdown, Space } from 'antd';
import {
  TeamOutlined, SettingOutlined, LogoutOutlined, UserOutlined,
  DollarOutlined, FileTextOutlined, ThunderboltOutlined, ToolOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Header, Sider, Content } = Layout;

function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Déterminer la clé sélectionnée pour les sous-menus
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path.startsWith('/admin/billing/subscriptions')) return '/admin/billing/subscriptions';
    if (path.startsWith('/admin/billing/invoices')) return '/admin/billing/invoices';
    if (path.startsWith('/admin/billing/events')) return '/admin/billing/events';
    if (path.startsWith('/admin/billing/config')) return '/admin/billing/config';
    return path;
  };

  const getOpenKeys = () => {
    if (location.pathname.startsWith('/admin/billing')) return ['billing'];
    return [];
  };

  const siderMenuItems = [
    {
      key: '/admin/tenants',
      icon: <TeamOutlined />,
      label: 'Tenants',
    },
    {
      key: 'billing',
      icon: <DollarOutlined />,
      label: 'Billing',
      children: [
        {
          key: '/admin/billing/subscriptions',
          icon: <TeamOutlined />,
          label: 'Abonnements',
        },
        {
          key: '/admin/billing/invoices',
          icon: <FileTextOutlined />,
          label: 'Factures',
        },
        {
          key: '/admin/billing/events',
          icon: <ThunderboltOutlined />,
          label: 'Webhooks',
        },
        {
          key: '/admin/billing/config',
          icon: <ToolOutlined />,
          label: 'Configuration',
        },
      ],
    },
    {
      key: '/admin/config',
      icon: <SettingOutlined />,
      label: 'Config SaaS',
    },
  ];

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Déconnexion',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={220} style={{ background: '#0F172A' }}>
        <div style={{
          height: 64, display: 'flex', alignItems: 'center',
          justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}>
          <Typography.Title level={4} style={{ margin: 0, color: '#FFFFFF', fontWeight: 700 }}>
            Cleo SaaS
          </Typography.Title>
        </div>

        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          defaultOpenKeys={getOpenKeys()}
          onClick={({ key }) => {
            if (!key.startsWith('billing')) navigate(key);
          }}
          items={siderMenuItems}
          style={{ background: '#0F172A', borderRight: 'none', marginTop: 8 }}
        />
      </Sider>

      <Layout>
        <Header style={{
          background: '#FFFFFF', borderBottom: '1px solid #E5E7EB',
          boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 24px', height: 64,
        }}>
          <Typography.Title level={4} style={{ margin: 0, color: '#0F172A', fontWeight: 600 }}>
            Administration SaaS
          </Typography.Title>

          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <Space style={{ cursor: 'pointer' }}>
              <div style={{
                width: 32, height: 32, borderRadius: '50%',
                background: '#0F172A', color: '#FFFFFF',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 13, fontWeight: 600,
              }}>
                {user?.email?.[0]?.toUpperCase() || <UserOutlined />}
              </div>
              <Typography.Text style={{ color: '#64748B', fontSize: 13 }}>
                {user?.email}
              </Typography.Text>
            </Space>
          </Dropdown>
        </Header>

        <Content style={{ padding: 24, background: '#F8FAFC' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default AdminLayout;
